export default {"src":"/_next/static/media/personal-loan.cda457a2.svg","height":36,"width":45,"blurWidth":0,"blurHeight":0};